import jp from 'jsonpath'
import { parseMetadata } from '../apps/professional-app/fa/MeetingSummary/utils'
import { Scorecard as ScorecardModel } from '../models/Scorecard'

export const SOURCE_TYPE_MAPPING: { [key: string]: string } = {
  meeting: 'meeting',
  user: 'user',
  crm: 'CRM',
  email: 'email',
  crossClientQuery: 'client query',
}

export const formatDate = (date: Date) => {
  const dateFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })

  return dateFormatter.format(date)
}

function convertKey(input: string) {
  let parts = input.split('.')

  for (let i = 0; i < parts.length; i++) {
    if (parts[i].includes('[')) {
      parts[i] = parts[i].replace(/\[\d+\]/, '.items')
    }

    parts[i] = 'properties.' + parts[i]
  }
  return parts.join('.')
}

export enum ScorecardLabelLevel {
  BLOCK = 'block',
  SECTION = 'section',
  PROPERTY = 'property',
}

interface NameFields {
  firstName?: string
  lastName?: string
  name?: string

  [key: string]: any
}

const fullNameStrategy = (person: NameFields): string => {
  const { firstName, lastName, name } = person

  if (!firstName && !lastName) {
    return name || 'unknown name'
  }

  if (firstName && !lastName) {
    return firstName
  }

  if (!firstName && lastName) {
    return lastName
  }

  return `${firstName} ${lastName}`
}

const staticStrategy = (
  schema: { [key: string]: any },
  path: string,
  value: {
    [key: string]: any
  },
): string => {
  const key = convertKey(path)
  return jp.value(schema, `$.${key}.title`) ?? ''
}

const executeStrategy = (
  schema: { [key: string]: any },
  path: string,
  value: {
    [key: string]: any
  },
  strategy: string,
): string => {
  if (strategy === 'fullname') {
    return fullNameStrategy(value)
  }
  return staticStrategy(schema, path, value)
}

export const getLabel = (
  schema: { [key: string]: any },
  path: string,
  value: {
    [key: string]: any
  },
  level: ScorecardLabelLevel,
  metadata?: string,
): string => {
  const labelConfig = parseMetadata(metadata)['labelConfig'] ?? ''
  const strategy = labelConfig ? labelConfig[level] : 'static'
  return executeStrategy(schema, path, value, strategy)
}

export function sortClientProfiles(scorecards: ScorecardModel[]) {
  return scorecards.sort((a, b) => {
    const metaA = parseMetadata(a.metadata)
    const metaB = parseMetadata(b.metadata)

    const displayPositionA = metaA.displayPosition
    const displayPositionB = metaB.displayPosition

    if (displayPositionA !== undefined && displayPositionB !== undefined && displayPositionA !== displayPositionB) {
      return displayPositionA - displayPositionB
    }

    if (displayPositionA !== undefined) {
      return -1
    }
    if (displayPositionB !== undefined) {
      return 1
    }

    return a.name.localeCompare(b.name)
  })
}
